export function isStringAuthorizeHtml(str) {
  return /^\[HTML\]/.test(str) && /\[\/HTML\]$/.test(str);
}
export function authorizeHtml(str) {
  if (typeof str === 'string') {
    return `[HTML]${str}[/HTML]`;
  }
  function authorizeHtmlInObject(obj) {
    return Object.keys(obj).reduce((acc, key) => ({
      ...acc,
      [key]: authorizeHtml(obj[key])
    }), {});
  }
  return authorizeHtmlInObject(str);
}
export function unprotectAuthorizedHtml(str) {
  if (typeof str === 'string') {
    return str.replace('[HTML]', '').replace('[/HTML]', '');
  }
  function unprotectAuthorizedHtmlInObject(obj) {
    return Object.keys(obj).reduce((acc, key) => ({
      ...acc,
      [key]: unprotectAuthorizedHtml(obj[key])
    }), {});
  }
  return unprotectAuthorizedHtmlInObject(str);
}